"use client";

import React from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { Box, Flex, IconButton, Text } from "@chakra-ui/react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";

// Chakra-compatible calendar wrapper
export function Calendar({ showOutsideDays = true, ...props }) {
  return (
    <Box p={3}>
      <DayPicker
        showOutsideDays={showOutsideDays}
        components={{
          IconLeft: ({ ...props }) => (
            <IconButton
              icon={<ChevronLeftIcon />}
              size="sm"
              variant="ghost"
              {...props}
              aria-label="Previous month"
            />
          ),
          IconRight: ({ ...props }) => (
            <IconButton
              icon={<ChevronRightIcon />}
              size="sm"
              variant="ghost"
              {...props}
              aria-label="Next month"
            />
          ),
        }}
        classNames={{
          months: "chakra-ui-calendar-months",
          month: "chakra-ui-calendar-month",
          caption: "chakra-ui-calendar-caption",
          caption_label: "chakra-ui-calendar-caption-label",
          nav: "chakra-ui-calendar-nav",
          nav_button: "chakra-ui-calendar-nav-button",
          nav_button_previous: "chakra-ui-calendar-nav-button-prev",
          nav_button_next: "chakra-ui-calendar-nav-button-next",
          table: "chakra-ui-calendar-table",
          head_row: "chakra-ui-calendar-head-row",
          head_cell: "chakra-ui-calendar-head-cell",
          row: "chakra-ui-calendar-row",
          cell: "chakra-ui-calendar-cell",
          day: "chakra-ui-calendar-day",
          day_selected: "chakra-ui-calendar-day-selected",
          day_today: "chakra-ui-calendar-day-today",
          day_outside: "chakra-ui-calendar-day-outside",
          day_disabled: "chakra-ui-calendar-day-disabled",
        }}
        {...props}
      />
    </Box>
  );
}
